import Vue from 'vue';

Vue.component('index-executive-director', require('./components/accreditation/Index').default);
Vue.component('tab-on-old', require('./components/accreditation/Tabs/OnHold').default);
Vue.component('tab-desicion-making', require('./components/accreditation/Tabs/Decision/DecisionMaking').default);
Vue.component('tab-autorization-request', require('./components/accreditation/Tabs/AuthorizationRequestEntry').default);
Vue.component('recommendation-index', require('./components/accreditation/Tabs/RecommendationIndex').default);
Vue.component('decision-index', require('./components/accreditation/Tabs/Decision/DecisionIndex').default);

/**
 * RARC
 */
// Validación Legal
Vue.component('legal-validation-tabs', require('./components/legal-validation/Tabs').default);
Vue.component('legal-validation-610-table', require('./components/legal-validation/610/Index').default);
Vue.component('legal-validation-610-tabs', require('./components/legal-validation/610/Tabs').default);
Vue.component('legal-validation-610-annexes', require('./components/legal-validation/610/annexes/Index').default);
Vue.component('legal-validation-610-annexes-modal', require('./components/legal-validation/610/annexes/Modal').default);

// Validación Legal Director
Vue.component('legal-validation-613-tabs-main', require('./components/legal-validation/TabsApproved').default);
Vue.component('legal-validation-613-table', require('./components/legal-validation/613/Index').default);
Vue.component('legal-validation-613-tabs', require('./components/legal-validation/613/Tabs').default);
Vue.component('legal-validation-613-annexes', require('./components/legal-validation/613/annexes/Index').default);
Vue.component('legal-validation-613-annexes-modal', require('./components/legal-validation/613/annexes/Modal').default);

// Emisión de Resolución
Vue.component('issuance-resolution-tabs', require('./components/issuance-resolution/Tabs').default);
Vue.component('issuance-resolution-612-table', require('./components/issuance-resolution/612/Index').default);
Vue.component('issuance-resolution-612-tabs', require('./components/issuance-resolution/612/Tabs').default);
Vue.component('issuance-resolution-612-annexes', require('./components/issuance-resolution/612/annexes/Index').default);
Vue.component('issuance-resolution-612-annexes-modal', require('./components/issuance-resolution/612/annexes/Index').default);